import * as Route from "./route";
import * as Roads from "./roads";
import * as IFrame from "./iframe";
import * as Member from "./member";
import * as Places from "./places";
import * as Helpers from "./helpers";
import * as Countries from "./countries";
import * as Analytics from "./analytics";
import * as Categories from "./categories";
import * as Graphhopper from "./graphhopper";
import * as Coordinates from "./coordinates";

export const Utils = {
  Route,
  Roads,
  Places,
  Member,
  IFrame,
  Helpers,
  Countries,
  Analytics,
  Categories,
  Graphhopper,
  Coordinates,
};
